module.exports = __webpack_public_path__ + "static/media/madfit-8.f78cadea.jpg";